import React from 'react';

import { MapStatsUtil } from '../../../../utils/map_stats_util';
import { ModalFunnelUtil } from '../../../../utils/modal_funnel_util';
import { PageStrings } from '../../../../utils/page_strings_util';
import { ServerCommunicationUtil } from '../../../../utils/server_communication_util';
import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';
import { MapDownloadButton } from '../feeds/map_download_button';

const createReactClass = require('create-react-class');

const StatsTab = createReactClass({
  getInitialState() {
    return {
      hide: false,
      refreshComplete: false,
      percentVerified: null,
      editingEndpoint: false
    };
  },
  componentDidMount() {
    if (this.props.messagingChannel) {
      this.props.messagingChannel.subscribe('map.percent_verified_updated', this.updatePercentVerified);
    }
  },
  updatePercentVerified(percentVerified) {
    if (this.state) this.setState({ percentVerified });
  },
  handleRefreshMapClick(e) {
    this.props.handleRefreshSubmit(
      this.props.data,
      function() {
        this.setState({ refreshComplete: true });
      }.bind(this)
    );
    return false;
  },
  handleEditEndpointClick(e) {
    if (this.state.editingEndpoint && !confirm(StringConstantsMixin.strings.TRACK_DETAIL.ENDPOINT_CONFIRMATION)) {
      return;
    }
    const newState = { editingEndpoint: !this.state.editingEndpoint };
    this.props.messagingChannel.publish('map.edit-endpoint-state-changed', newState);
    this.setState(newState);
  },
  handleCancelEditClick(e) {
    if (!this.state.editingEndpoint) {
      return;
    }
    this.props.messagingChannel.publish('map.edit-endpoint-state-changed', { editingEndpoint: false, canceled: true });
    this.setState({ editingEndpoint: false });
  },
  handleShareClick(e) {
    this.props.handleShareClick({
      type: this.props.data.presentationType,
      ugc: true,
      id: this.props.data.id,
      slug: this.props.data.slug,
      name: this.props.data.name,
      private: this.props.data.private
    });
  },
  renderPercentVerified() {
    if (typeof this.state.percentVerified !== 'number') {
      return null;
    }
    return ` - ${this.state.percentVerified}%`;
  },
  renderStaticMap() {
    const staticMapUrl = `/api/alltrails/maps/${this.props.data.id}/static_map?size=480x200&key=${ServerCommunicationUtil.apiKey}`;
    const onClick = function(e) {
      this.props.messagingChannel.publish('map.show');
    }.bind(this);
    return (
      <div className="static-map link">
        <a onClick={onClick}>
          <img className="track-map-image" src={staticMapUrl} />
        </a>
        <a onClick={onClick} className="full-map-expand">
          <div>{StringConstantsMixin.strings.VIEW_FULL_MAP}</div>
        </a>
      </div>
    );
  },
  renderDirectionsLink() {
    let directionsLink = null;
    if (this.props.currentUser) {
      if (this.props.data && this.props.data.location) {
        directionsLink = (
          <span className="btn btn-slim blue rounded write-review pull-right gpx-dl">
            <a
              href={`https:///www.google.com/maps/dir/Current+Location/${this.props.data.location.latitude},${this.props.data.location.longitude}`}
              target="_blank"
            >
              {StringConstantsMixin.strings.TRACK_DETAIL.DIRECTIONS}
            </a>
          </span>
        );
      }
    } else if (typeof window != 'undefined') {
      const returnToUrl = window.location.pathname + window.location.search;
      directionsLink = (
        <span className="btn btn-slim blue rounded write-review pull-right gpx-dl">
          <a onClick={ModalFunnelUtil.modalSignup.bind(this, null, 'explore-atmap-directions', returnToUrl)}>
            {StringConstantsMixin.strings.TRACK_DETAIL.DIRECTIONS}
          </a>
        </span>
      );
    }
    return directionsLink;
  },
  renderButtonContainer() {
    // Don't show buttons on mobile
    if (this.props.isMobileWidth) {
      return null;
    }

    // Download GPX Link
    let gpxLink;
    const trackDetail = StringConstantsMixin.strings.TRACK_DETAIL;
    const gpxLinkText = this.props.data.routes && this.props.data.routes.length > 1 ? trackDetail.DOWNLOAD_ROUTES : trackDetail.DOWNLOAD_ROUTE;
    if (this.props.currentUser && this.props.data) {
      // Any logged-in user can download GPX. (If it is not their map, then the map must be public if they are here)
      gpxLink = <MapDownloadButton apiKey={ServerCommunicationUtil.apiKey} btnText={gpxLinkText} mapId={this.props.data.id} />;
    } else if (typeof window != 'undefined') {
      const returnToUrl = window.location.pathname + window.location.search;
      gpxLink = (
        <span className="btn btn-slim blue rounded write-review pull-right gpx-dl">
          <a onClick={ModalFunnelUtil.modalSignup.bind(this, null, 'explore-gpx-download', returnToUrl)}>{gpxLinkText}</a>
        </span>
      );
    }

    // Admin-only Refresh Link
    let adminRefreshLink = null;
    if (this.props.currentUser && this.props.currentUser.admin) {
      if (this.state.refreshComplete) {
        adminRefreshLink = <span className="btn btn-slim blue rounded write-review pull-right gpx-dl">Refreshed</span>;
      } else {
        adminRefreshLink = (
          <span className="btn btn-slim blue rounded write-review pull-right gpx-dl">
            <a onClick={this.handleRefreshMapClick}>Refresh</a>
          </span>
        );
      }
    }

    // Edit Endpoint Link
    let editEndpointLink = null;
    let cancelEditLink = null;
    if (
      this.props.currentPage === PageStrings.EXPLORE_USERS_TRACKS_MAP_PAGE &&
      this.props.currentUser &&
      (this.props.currentUser.admin || (this.props.data && this.props.currentUser.id === this.props.data.user.id))
    ) {
      editEndpointLink = (
        <span className="btn btn-slim blue rounded write-review pull-right gpx-dl">
          <a onClick={this.handleEditEndpointClick}>
            {this.state.editingEndpoint
              ? StringConstantsMixin.strings.TRACK_DETAIL.SAVE_ENDPOINT
              : StringConstantsMixin.strings.TRACK_DETAIL.EDIT_ENDPOINT}
          </a>
        </span>
      );
      if (this.state.editingEndpoint) {
        cancelEditLink = (
          <span className="btn btn-slim blue rounded write-review pull-right gpx-dl">
            <a onClick={this.handleCancelEditClick}>{StringConstantsMixin.strings.CANCEL_EDIT}</a>
          </span>
        );
        // remove adminRefreshLink
        adminRefreshLink = null;
      }
    }

    // Share Link
    let shareLink = null;
    if (
      this.props.data &&
      (this.props.currentPage === PageStrings.EXPLORE_USERS_TRACKS_MAP_PAGE || this.props.currentPage === PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE)
    ) {
      let clickHandler;
      if (this.props.currentUser) {
        clickHandler = this.handleShareClick;
      } else if (typeof window != 'undefined') {
        const returnToUrl = window.location.pathname + window.location.search;
        clickHandler = ModalFunnelUtil.modalSignup.bind(this, null, 'explore-atmap-share', returnToUrl);
      }
      shareLink = (
        <span className="btn btn-slim blue rounded write-review pull-right gpx-dl">
          <a onClick={clickHandler}>{StringConstantsMixin.strings.SHARE}</a>
        </span>
      );
    }

    // Directions (link to Google Maps)
    const directionsLink = this.renderDirectionsLink();

    // Button Container
    if (adminRefreshLink || gpxLink || editEndpointLink || cancelEditLink || shareLink || directionsLink) {
      return (
        <span className="pull-right">
          <span className="pull-right">
            {cancelEditLink}
            {editEndpointLink}
            {adminRefreshLink}
          </span>
          <span className="pull-right">
            {shareLink}
            {gpxLink}
            {directionsLink}
          </span>
        </span>
      );
    }
    return null;
  },
  getPaceOrSpeed(stats, metric) {
    if (this.props.currentUser && this.props.currentUser.displaySpeed) {
      const mapAvgSpeedVal = MapStatsUtil.avgSpeed(stats, metric);
      const mapAvgSpeed = MapStatsUtil.speedFormatted(mapAvgSpeedVal, metric);
      return {
        label: StringConstantsMixin.strings.STATS.NORMAL.AVG_SPEED,
        value: mapAvgSpeed
      };
    }
    const mapAvgPaceVal = MapStatsUtil.avgPace(stats, metric);
    const mapAvgPace = MapStatsUtil.timeFormatted(mapAvgPaceVal, metric);
    return {
      label: StringConstantsMixin.strings.STATS.NORMAL.AVG_PACE,
      value: mapAvgPace
    };
  },
  render() {
    if (this.props.hide) {
      return null;
    }

    const nA = '--';
    let mapTotalDistance = nA;
    let mapElevationGain = nA;
    let mapMovingTime = nA;
    let mapTotalTime = nA;
    let mapCalories = nA;
    let mapPaceOrSpeed = {
      label: nA,
      value: nA
    };

    const stats = this.props.data.summaryStats;
    if (stats) {
      const metric = this.props.displayMetric;
      const mapTotalDistanceVal = MapStatsUtil.totalDistance(stats, metric);
      const mapElevationGainVal = MapStatsUtil.elevationGain(stats, metric);

      mapTotalDistance = MapStatsUtil.distanceFormatted(mapTotalDistanceVal, metric);
      mapElevationGain = MapStatsUtil.elevationFormatted(mapElevationGainVal, metric);
      mapMovingTime = MapStatsUtil.timeFormatted(stats.timeMoving);
      mapTotalTime = MapStatsUtil.timeFormatted(stats.timeTotal);
      mapCalories = MapStatsUtil.caloriesFormatted(stats.calories);
      mapPaceOrSpeed = this.getPaceOrSpeed(stats, metric);
    }

    return (
      <div id="total-stats" className={StringConstantsMixin.constants.XLATE.NONE}>
        <div className="action-bar">
          <menu className="title clearfix overview-menu tabs inline-menu">
            <li className="active">
              <h3>
                <a name={StringConstantsMixin.strings.STATS.NORMAL.STATS}>
                  {StringConstantsMixin.strings.STATS.NORMAL.STATS}
                  {this.renderPercentVerified()}
                </a>
              </h3>
            </li>
          </menu>
          {this.renderButtonContainer()}
        </div>
        <div className="stats-section first">
          <span className="total-distance stat">
            <div className="stats-label">{StringConstantsMixin.strings.STATS.NORMAL.DISTANCE}</div>
            <div className="data">{mapTotalDistance}</div>
          </span>
          <span className="elevation-gain stat">
            <div className="stats-label">{StringConstantsMixin.strings.STATS.NORMAL.ELEVATION_GAIN}</div>
            <div className="data">{mapElevationGain}</div>
          </span>
          {this.props.currentPage !== PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE && (
            <span className="moving-time stat">
              <div className="stats-label">{StringConstantsMixin.strings.STATS.NORMAL.MOVING_TIME}</div>
              <div className="data">{mapMovingTime}</div>
            </span>
          )}
        </div>
        {this.props.currentPage !== PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE && (
          <div className="stats-section">
            <span className="avg-speed stat">
              <div className="stats-label">{mapPaceOrSpeed.label}</div>
              <div className="data">{mapPaceOrSpeed.value}</div>
            </span>
            <span className="calories stat">
              <div className="stats-label">{StringConstantsMixin.strings.STATS.NORMAL.CALORIES}</div>
              <div className="data">{mapCalories}</div>
            </span>
            <span className="total-time stat">
              <div className="stats-label">{StringConstantsMixin.strings.STATS.NORMAL.TOTAL_TIME}</div>
              <div className="data">{mapTotalTime}</div>
            </span>
          </div>
        )}
        {this.renderStaticMap()}
      </div>
    );
  }
});

export { StatsTab };
